<div class="size-properties">
  <div class="size-properties-value">{{ fontSizeNumber }}</div>
  <fa-icon
    matRipple
    [icon]="['fas', 'chevron-up']"
    size="sm"
    matTooltip="Increase font size"
    (click)="fontSizeChanged.emit(fontSizeNumber + 1)"
    [intercomTarget]="'toolbar-context-menu-font-size-up'"
  ></fa-icon>
  <fa-icon
    matRipple
    [icon]="['fas', 'chevron-down']"
    size="sm"
    matTooltip="Decrease font size"
    (click)="fontSizeChanged.emit(fontSizeNumber - 1)"
    [intercomTarget]="'toolbar-context-menu-font-size-down'"
  ></fa-icon>
</div>
